<ion-header class="ion-no-border modal-header">
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-icon *ngIf="!hideCloseButton"
                      (click)="close()"
                      slot="icon-only"
                      class="icon haleo-close"></ion-icon>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-text-center ui-2022">
    <div class="modal-content">
        <i *ngIf="icon" class="{{icon}}"></i>
        <h3 [class.no-description]="!description || description === ''" [class]="titleColor">
            {{'ui.newPopover.' + title | translate}}
        </h3>
        <div *ngIf="description && description !== ''"
             [class.notification-settings-instructions]="notificationSettings"
             [innerHTML]="'ui.newPopover.' + description | translate">
        </div>
    </div>

</ion-content>
<ion-footer class="ion-no-border ui-2022 modal-footer">
    <div>
        <ion-buttons *ngIf="buttons && buttons.length > 0">
            <ion-button *ngFor="let button of buttons"
                        [color]="button.color? button.color: 'secondary'"
                        [class.btn-link]="!button.type"
                        [fill]="button.type"
                        (click)="button.handler()">
                {{'ui.newPopover.' + button.label | translate}}
            </ion-button>
        </ion-buttons>
    </div>
</ion-footer>
